export default __webpack_public_path__ + "static/mask-slant-107e37535ab61bfd4930b1fa59c91c9c.svg";